var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "overview-tab dashboard-tab" }, [
    _c(
      "div",
      {
        staticClass: "d-flex overview-row justify--space-around justify--start",
      },
      [
        _c("div", { staticClass: "overview-col" }, [
          _c("div", { staticClass: "overview-item" }, [
            _c(
              "div",
              { staticClass: "overview-icon-container" },
              [_c("vuestic-icon-vue")],
              1
            ),
            _vm._v("\n        Built with Vue.js framework\n      "),
          ]),
          _c("div", { staticClass: "overview-item" }, [
            _c(
              "div",
              { staticClass: "overview-icon-container" },
              [_c("vuestic-icon-free")],
              1
            ),
            _vm._v("\n        Absolutely free for everyone\n      "),
          ]),
          _c("div", { staticClass: "overview-item" }, [
            _c(
              "div",
              { staticClass: "overview-icon-container" },
              [_c("vuestic-icon-fresh")],
              1
            ),
            _vm._v("\n        Fresh and crisp design\n      "),
          ]),
        ]),
        _c("div", { staticClass: "overview-col" }, [
          _c("div", { staticClass: "overview-item" }, [
            _c(
              "div",
              { staticClass: "overview-icon-container" },
              [_c("vuestic-icon-responsive")],
              1
            ),
            _vm._v("\n        Responsive and optimized for mobile\n      "),
          ]),
          _c("div", { staticClass: "overview-item" }, [
            _c(
              "div",
              { staticClass: "overview-icon-container" },
              [_c("vuestic-icon-rich")],
              1
            ),
            _vm._v("\n        Tons of useful components\n      "),
          ]),
          _c("div", { staticClass: "overview-item" }, [
            _c(
              "div",
              { staticClass: "overview-icon-container" },
              [_c("vuestic-icon-clean-code")],
              1
            ),
            _vm._v("\n        Completely jQuery free\n      "),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }